import { graphql } from "msw";
import { range } from "ramda";
import { getFaker } from "Apimocks/utils/getFaker";
import { getUsers } from "../users/users.handler";

let groups;
let projectUsers;

const makeGroups = async () => {
    const faker = await getFaker();
    faker.seed(1);
    const users = await getUsers();
    // eslint-disable-next-line no-magic-numbers
    const groupsList = range(0,10).map(i => ({
        created: faker.time.recent(),
        description: faker.lorem.sentence(),
        hasChildGroups: faker.random.boolean(),
        hasRoles: faker.random.boolean(),
        id: `${i}`,
        lastUpdated: faker.time.recent(),
        members: faker.random.arrayElements(users, faker.random.number({
            min: 1,
            max: 20
        })),
        name: faker.lorem.words(),
        path: "",
    }));
    // ensure that one group has docgroup properties for workflow widget
    groupsList[0].hasRoles = true;
    groupsList[0].hasChildGroups = false;
    groupsList[0].name = "docgroup - testdoc";
    groupsList[0].name = "docgroup - testdoc";
    groupsList[0].related = "global.document";
    groupsList[0].relatedModel = "document";
    groups = groupsList;
    projectUsers = users;
    return groupsList;
};

export const getGroups = async () => {
    if (groups) return groups;
    const newGroups = await makeGroups();
    return newGroups;
};

const getSingleGroup = async groupId => {
    if (groups) return groups.find(({ id }) => id === groupId);
    const newGroups = await makeGroups();
    return newGroups.find(({ id }) => id === groupId);
};

const addGroup = async groupDetails => {
    if (!groups) {
        await makeGroups();
    }
    const newGroup = { ...groupDetails, id: `${groups.length + 1}`, members: [], lastUpdated: Date.now() };
    groups.push(newGroup);
    return newGroup;
};

const updateGroup = async ({ id, name, description }) => {
    if (!groups) {
        await makeGroups();
    }
    const group = groups.find(({ id: gid }) => id === gid);
    Object.assign(group, { name, description });
    return group;
};

const deleteGroup = async ({ id }) => {
    if (!groups) {
        await makeGroups();
    }
    groups = groups.splice(groups.findIndex(({ id: gid }) => gid === id), 1);
    return id;
};

export const handlers = [
    graphql.query("loadGroupsInProject", async (req, res, ctx) => {
        const groupsList = await getGroups();
        return res(ctx.delay(), ctx.data({ currentProject: {
            __typename: "Project",
            _id: "1",
            groups: groupsList,
            availableusers: { edges: projectUsers }
        } }));
    }),
    graphql.query("viewProjectGroup", async (req, res, ctx) => {
        const group = await getSingleGroup(req.variables.groupId) || {};
        if (group) return res(ctx.delay(), ctx.data({ viewProjectGroup: group }));
        // eslint-disable-next-line no-magic-numbers
        return res(ctx.delay(), ctx.status(404), ctx.data({ error: `Group not found: ${req.variables.id}` }));
    }),
    graphql.mutation("createProjectGroup", async (req, res, ctx) => {
        const newGroup = await addGroup(req.variables);
        res(
            ctx.delay(),
            ctx.data({ createProjectGroup: newGroup })
        );
    }),
    graphql.mutation("updateProjectGroup", async (req, res, ctx) => {
        const newGroup = await updateGroup(req.variables);
        res(
            ctx.delay(),
            ctx.data({ createProjectGroup: newGroup })
        );
    }),
    graphql.mutation("deleteProjectGroup", async (req, res, ctx) => {
        const newGroup = await deleteGroup(req.variables);
        res(
            ctx.delay(),
            ctx.data({ deleteProjectGroup: { id: newGroup.id } })
        );
    })
];
